import React, { forwardRef } from 'react';

export interface ThreeDViewProps extends React.HTMLAttributes<HTMLDivElement> {
  onCanvasMount?: (node: HTMLDivElement | null) => void;
  status?: string;
  errorMessage?: string | null;
  onRetry?: () => void;
}

/**
 * ThreeDView component: Hosts the 3D WebGL Canvas Viewport with responsive
 * aspect ratio synchronization and CSS object-fit: contain to prevent 3D model distortion.
 */
export const ThreeDView = forwardRef<HTMLDivElement, ThreeDViewProps>(({
  className = '',
  onCanvasMount,
  children,
  ...props
}, ref) => {
  return (
    <div 
      className={`relative w-full h-full overflow-hidden flex items-center justify-center ${className}`}
      {...props}
    >
      <div
        ref={(node) => {
          if (typeof ref === 'function') {
            ref(node);
          } else if (ref) {
            (ref as any).current = node;
          }
          if (onCanvasMount) {
            onCanvasMount(node);
          }
        }}
        className="absolute inset-0 w-full h-full flex items-center justify-center cursor-grab active:cursor-grabbing outline-none [&>canvas]:max-w-full [&>canvas]:max-h-full [&>canvas]:w-full [&>canvas]:h-full [&>canvas]:object-contain"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      />
      {children}
    </div>
  );
});

ThreeDView.displayName = 'ThreeDView';

export default ThreeDView;
